<template>
  <card class="goods-info">
    <AdminTitle title="订单信息" size="20px"></AdminTitle>

    <div class="goods-info-detail">
      <el-image
        style="
          width: 100px;
          border-radius: 8px;
          height: 100px;
          margin-right: 20px;
        "
        :src="detailInfo.orderGoods ? detailInfo.orderGoods.skuCoverImageUrl : ''"
        :preview-src-list="[detailInfo.orderGoods ? detailInfo.orderGoods.skuCoverImageUrl : '']"
      >
        <div
          style="
            background: #f5f7fa;
            width: 100px;
            height: 100px;
            line-height: 100px;
            text-align: center;
            color: #c0c4cc;
          "
          slot="error"
        >
          暂无图片
        </div>
      </el-image>
      <div class="goods-info-detail-right">
        <div class="goods-title fw700">
          {{ detailInfo.orderGoods ? detailInfo.orderGoods.skuTitle : "" }}

          <el-button
              v-if="detailInfo.status >= 4 && detailInfo.status <= 91"
              type="primary"
              size="small"
              @click="handleEditTag"
          >
            编辑标签
          </el-button>
        </div>
        <div class="order-tag-list">
          <div class="order-tag">
            <el-tag
              :type="detailInfo.orderGoods && detailInfo.orderGoods.goodsPurityName
              ? detailInfo.orderGoods.goodsPurityName == '全新' ? 'success' : 'warning'
              : 'success'"
            >
              {{ detailInfo.orderGoods ? detailInfo.orderGoods.goodsPurityName : "" }}
            </el-tag>

            <el-tag type="success">{{ detailInfo.orderTypeName }}</el-tag>

            <el-tag type="info">{{ detailInfo.statusName }}</el-tag>

            <el-tag v-for="(item, index) in detailInfo.orderRiskTagNameList" :key="index">
              {{ item }}
            </el-tag>
          </div>
          <div class="withhold-tag">
            <el-tag
                v-if="shouldShowWithholdChannel(detailInfo.withholdChannel)"
                :type="getWithholdChannelType(detailInfo.withholdChannel)"
            >
              {{ getWithholdChannelText(detailInfo.withholdChannel) }}
            </el-tag>
          </div>
        </div>
        <div class="label">订单号：{{ $route.params.id }}</div>
        <div class="label">下单时间：{{ detailInfo.createTime }}</div>
      </div>
    </div>

    <div class="kf-detail">
      <span class="kf-title">客服：</span>
      <SelectAdminUser
        v-model="kfUserId"
        ref="kfRef"
        :job-code="AdminJobCode.A004"
        :clearable="false"
        :disable="isShowBtn(AUTH_BTN.order_list_detail_update_kf) === 0"
        @input="handleUpdateKf"
      />
      <!-- <el-link
          v-if="kfUserId > 0 && detailInfo.status < 6"
          style="margin-left: 10px"
          type="primary"
          :disable="isShowBtn(AUTH_BTN.order_list_detail_customer_link) === 0"
          @click="getCustomerAcquisitionLink"
      >
        获客链接
      </el-link> -->
    </div>

    <div class="kf-detail">
      <span class="kf-title">市场助理：</span>
      <SelectAdminUser
          v-model="maUserId"
          ref="maRef"
          :job-code="AdminJobCode.A002"
          :clearable="false"
          :disable="isShowBtn(AUTH_BTN.order_list_detail_update_ma) === 0"
          @input="handleUpdateMaUser"
      />
    </div>

    <div class="cost-details">
      <div class="cost-title">费用明细</div>
    </div>
    <card class="goods-info special-card">
      <el-row>
        <el-col
          :span="item.width ? item.width : 8"
          v-for="(item, index) in orderInfoList"
          :key="index"
        >
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ detailInfo[item.prop] || "" }}{{ item.unit }}</span>
        </el-col>
      </el-row>
    </card>

    <el-dialog
      title="风控标签"
      :visible.sync="riskTagDialog"
      width="70%"
      :show-close="true"
    >
      <div class="risk-tag" v-for="(tag0, idx0) in riskTagTree" :key="idx0">
        <div class="title">
          <span>{{ tag0.tagName }}</span>
        </div>
        <el-radio-group v-model="riskTagFormData['tag' + tag0.tagCode]" class="radio-group">
          <el-radio-button
              v-for="(tag1, idx1) in tag0.children"
              :key="idx1"
              :label="tag1.tagCode"
              @click.native.prevent="handleRiskTagToggle(tag0.tagCode, tag1.tagCode)"
          >
            {{ tag1.tagName }}
          </el-radio-button>
        </el-radio-group>
      </div>

      <div slot="footer">
        <el-button @click="riskTagDialog = false" size="small">取 消</el-button>
        <el-button type="primary" @click="editRiskTag" size="small">保 存</el-button>
      </div>
    </el-dialog>
  </card>
</template>

<script>
import {
  getWithholdChannelText,
  getWithholdChannelType,
  shouldShowWithholdChannel,
} from "@/enum/dict/withholdChannel";
import {
  allocateOrderKfAPI, 
  getRiskTagTreeAPI, 
  editRiskTagAPI, 
  updateOrderMaUserAPI, 
  getCustomerAcquisitionLinkAPI,
} from "./api";
import { authBtnMixin } from "@/mixins/authBtnMixin";
import SelectAdminUser from "@/views/components/select-admin-user.vue";
import { AdminJobCode } from "@/enum/dict/index.js";

export default {
  name: "OrderInfo",
  mixins: [authBtnMixin],
  components: { SelectAdminUser },
  inject: ["reload"],

  props: {
    detailInfo: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      AdminJobCode,
      priceData: {
        salePrice: "",
        orderNo: "",
      },
      priceRateDialog: false,
      kfUserId: undefined,
      maUserId: undefined,
      storeComboList: [],
      orderInfoList: [
        {
          label: "总租金",
          prop: "rentPrice",
          unit: "元",
        },
        {
          label: "首付金额",
          prop: "prepayAmount",
          unit: "元",
        },
        {
          label: "方案",
          prop: "storeComboName",
        },
        {
          label: "租期",
          prop: "billPeriodNum",
          unit: "期",
        },
        {
          label: "首期租金",
          prop: "prepayRentPrice",
          unit: "元",
        },
        {
          label: "零售价",
          prop: "salePrice",
          unit: "元",
          edit: true,
        },
        {
          label: "买断金",
          prop: "buyoutPrice",
          unit: "元",
        },
        {
          label: "押金",
          prop: "prepayDepositPrice",
          unit: "元",
        },
        {
          label: "",
          prop: "",
          unit: "",
        },
        {
          label: "监管锁费",
          prop: "lockAmount",
          unit: "元",
        },
        {
          label: "保险金",
          prop: "insurancePrice",
          unit: "元",
        },
      ],
      updateFinalGradeDialog: false,
      periodDialog: false,
      riskTagDialog: false,
      riskTagFormData: null,
      riskTagTree: null,
      selectedRiskTagValue: '',
    };
  },

  watch: {
    detailInfo: {
      immediate: true,
      handler(newVal) {
        this.kfUserId = newVal.kfUserId;
        this.maUserId = newVal.maUserId;
      }
    }
  },

  methods: {
    getWithholdChannelText,
    getWithholdChannelType,
    shouldShowWithholdChannel,

    handleUpdateKf() {
      if (this.kfUserId == this.detailInfo.kfUserId) return;
      this.$nextTick(() => {
        this.$confirm(`确定设置为该订单的客服吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let params = {
              orderNo: this.detailInfo.orderNo,
              userId: this.kfUserId,
            };
            allocateOrderKfAPI(params).then(() => {
              this.detailInfo.kfUserId = this.kfUserId;
              this.$message.success('操作成功');
            })
          })
          .catch(() => {
            this.kfUserId = this.detailInfo.kfUserId;
            this.$message.info('已取消操作');
          })
          .finally(() => {
            this.$refs.kfRef.close();
          })
      });
    },

    handleUpdateMaUser() {
      if (this.maUserId == this.detailInfo.maUserId) return;
      this.$nextTick(() => {
        this.$confirm(`确定设置为该订单的市场助理吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
            .then(() => {
              let params = {
                orderNo: this.detailInfo.orderNo,
                maUserId: this.maUserId,
              };
              updateOrderMaUserAPI(params).then(() => {
                this.detailInfo.maUserId = this.maUserId;
                this.$message.success('操作成功');
              })
            })
            .catch(() => {
              this.maUserId = this.detailInfo.maUserId;
              this.$message.info('已取消操作');
            })
            .finally(() => {
              this.$refs.maRef.close();
            })
      });
    },

    async handleEditTag() {
      const riskTagTree = await getRiskTagTreeAPI();
      this.riskTagFormData = riskTagTree.reduce((acc, tag0) => {
        let rootTagCode = 'tag' + tag0.tagCode;
        acc[rootTagCode] = this.detailInfo.orderRiskTag?.[rootTagCode] || '';
        return acc;
      }, {});
      this.riskTagTree = riskTagTree;
      this.riskTagDialog = true;
    },

    handleRiskTagToggle(tag0Code, tag1Code) {
      let rootTagCode = 'tag' + tag0Code;
      if (!this.riskTagFormData[rootTagCode]) {
        this.riskTagFormData[rootTagCode] = tag1Code;
      } else {
        this.riskTagFormData[rootTagCode] = this.riskTagFormData[rootTagCode] === tag1Code ? '' : tag1Code;
      }
    },

    editRiskTag() {
      let params = {
        orderNo: this.detailInfo.orderNo,
        ...this.riskTagFormData,
      };
      editRiskTagAPI(params).then(() => {
        this.$emit("update:flag", false);
        this.$emit("updateDetail");
        this.$message.success("更新成功");
        this.riskTagDialog = false;
      });
    },

    async getCustomerAcquisitionLink() {
      const link = await getCustomerAcquisitionLinkAPI({orderNo: this.detailInfo.orderNo});
      console.log('link', link);
      this.$copyText(link).then(
        () => {
            this.$message.success('复制成功');
        },
        () => {
            this.$message.error('复制失败');
        }
      );
    }
  },
};
</script>

<style lang="scss" scoped>
.goods-info /deep/ {
  border-color: transparent;
  margin-top: 20px;
  width: 100%;
  border-radius: 16px;
  color: #222222;
  .label {
    color: #666666;
    font-size: 14px;
  }
  .ivu-card {
    border-radius: 18px;
  }
  .goods-info-detail {
    display: flex;
    .goods-info-detail-right {
      display: flex;
      flex-direction: column;
      .goods-title {
        display: flex;
        color: #333333;
        font-size: 16px;
        align-items: center;
        gap: 50px;
        .el-button {
          border-radius: 20px;
        }

        .btn {
          justify-content: center;
        }
      }
      .order-tag-list {
        display: flex;
      }
      .order-tag {
        margin-top: 8px;
        .el-tag.el-tag--success {
          background-color: #fff;
          color: #666666;
          border-color: #e4e4e4;
        }
        .el-tag.el-tag--warning {
          background-color: #fff;
          color: #f15f5f;
          border-color: #f15f5f;
        }
        .el-tag.el-tag--info {
          background-color: #fff;
          color: #ffac46;
          border-color: #ffac46;
        }
      }
      .withhold-tag {
        margin-top: 8px;
      }
      .label {
        margin-top: 8px;
        font-size: 12px;
      }
    }
    .el-tag {
      height: 25px;
      border-radius: 15px;
      margin-right: 10px;
      line-height: 25px;
    }
  }
  .kf-detail {
    margin: 10px 0;
    .kf-title {
      margin-top: 15px;
      color: #666666;
      font-size: 14px;
    }
  }
  .cost-details {
    .cost-title {
      margin-top: 15px;
      color: #666666;
      font-size: 14px;
    }
  }
  .el-dialog__footer {
    padding-bottom: 30px !important;
  }
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title-style {
      color: #333333;
      flex-wrap: 600;
      font-size: 16px;
    }
    .supple-inform-edit {
      cursor: pointer;
      background: #f7f8fa;
      color: #333333;
      padding: 8px 18px;
      border-radius: 45px;
    }
  }

  .update-final-grade-dialog {
    .el-dialog__footer {
      padding-top: 0;
    }
  }
}
.special-card {
  background: #f7f8fa;
  line-height: 35px;
  color: #222222;
  position: relative;
  .value {
    margin-left: 15px;
    min-width: 80px;
    display: inline-block;
    font-weight: 700;
  }
  .label {
    text-align: right;
    min-width: 80px;
    display: inline-block;
  }
  .el-icon-edit {
    margin-left: 30px;
    cursor: pointer;
    color: #4badf8;
  }
  &::after {
    content: "";
    display: inline-block;
    height: 80%;
    width: 1px;
    border-left: 1px dashed #e4e4e4;
    right: 33%;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
  }
}
.fei-box {
  .fei-item {
    margin-bottom: 10px;
    .title {
      font-weight: 700;
      font-size: 16px;
      margin-bottom: 10px;
    }
  }
}
.fw700 {
  font-weight: 700;
}

.risk-tag {
  margin: 20px;

  .title {
    font-size: 16px;
    font-weight: 700;
  }

  .radio-group /deep/ {
    display: flex;

    .el-radio-button {
      margin-right: 30px;
    }

    .el-radio-button__inner {
      width: 100px;
      height: 38px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      color: #409EFF;
      border-color: #409EFF;
      box-shadow: -1px 0 0 0 #409EFF;
      border-radius: 16px !important;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      color: #fff;
      background-color: #409EFF;
      border-color: #409EFF;
      box-shadow: -1px 0 0 0 #409EFF;
    }

    .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
      box-shadow: none !important;
      outline: none !important;
    }
  }
}
</style>
